import { render, staticRenderFns } from "./shippingAddress.vue?vue&type=template&id=152394fa&scoped=true"
import script from "./shippingAddress.vue?vue&type=script&lang=js"
export * from "./shippingAddress.vue?vue&type=script&lang=js"
import style0 from "./shippingAddress.vue?vue&type=style&index=0&id=152394fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152394fa",
  null
  
)

export default component.exports